// Copyright (c) 2020 Deere & Company

import MassUpdateRequestDetailsRoutes from '../../rga/mass-update/mass-update-request';

export default {
    component: MassUpdateRequestDetailsRoutes,
    name: 'Mass Update Request Details',
    path: '/rga/recalled/mass-update/selected-rga'
};




// WEBPACK FOOTER //
// ./src/routes/rga/rga-mass-update-selected-rga.js